export const MINDMAP_API_ROUTES = {
    GET_MINDMAP_LIST: '/mindmap/getmindmaplist',
    GET_FILE:'/mindmap/getmindmapsignfile',
    POST_NOTE_AND_BOOKMARK:'/mindmap/mindmapusercomment'
};
